import { render, staticRenderFns } from "./chooseWay.vue?vue&type=template&id=e803d190&scoped=true&"
import script from "./chooseWay.vue?vue&type=script&lang=js&"
export * from "./chooseWay.vue?vue&type=script&lang=js&"
import style0 from "./chooseWay.vue?vue&type=style&index=0&id=e803d190&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e803d190",
  null
  
)

export default component.exports